<!-- On vérifie que le rootForm existe avant de créer les champs liés -->
<div *ngIf="rootForm && lieuxBav && ! (modeRenduService.enModeImpression$ | async)">
  <div class="form-row mx-2 pb-3" *ngIf="rootForm && lieuxBav">
      <div class="col" [formGroup]="rootForm">
        <div>
        <mat-accordion class=" col-12">
          <div *ngFor="let item of lieuxBav.controls; let i = index">
            <mat-expansion-panel (opened)="setStep(i)">
              <mat-expansion-panel-header>
                <mat-panel-description>
                  <mat-icon>account_circle</mat-icon>&#xA0;
                  <span [ngClass]="{'onglet-invalide': lieuxBav.controls[i].invalid}">
                    Informations sur le bav {{ i + 1 }}
                  </span>
                </mat-panel-description>
              </mat-expansion-panel-header>
              <div class="form-row">
                  <div class="col-md-8">
                    <bis-filtered-select-input-keypad [preId]="i" [rootForm]="lieuxBav.controls[i]" nbChoixVisiblePossible="10" label="aaLieuBavIelst" 
                        nomNomenclature="ielstBav" [montreCode]="false" [enLectureSeule]="true">
                    </bis-filtered-select-input-keypad>
                  </div>
                  <div class="col-md-4">
                    <bis-filtered-select-input-keypad [preId]="i" [rootForm]="lieuxBav.controls[i]" label="aaLieuBavQp" 
                        infoBulle="Préciser dans le menu déroulant si le lieu de permanence est en quartier prioritaire" nomNomenclature="ouiNonNsp">
                    </bis-filtered-select-input-keypad>
                  </div>
              </div>
              <div class="form-row">
                  <div class="col-md-1"></div>
                  <div class="col-md-10">
                    <bis-integer-inline-input-keypad [preId]="i" [rootForm]="lieuxBav.controls[i]" classeColLabel="col-8" classeColInput="col-2" classeSupplInput="text-right" 
                        label="aaLieuBavNbPerm" [max]="999" infoBulle="1 demi-journée = 3h" [erreursCroisees]="['ctrlA64Bav']">
                    </bis-integer-inline-input-keypad>
                    <bis-affiche-erreurs-croisees [rootForm]="lieuxBav.controls[i]" colorErreur="danger"
                      labelErreur="ctrlA64Bav">
                    </bis-affiche-erreurs-croisees>
                  </div>
              </div>
              <div class="form-row">
                  <div class="col-md-1"></div>
                  <div class="col-md-10">
                      <bis-integer-inline-input-keypad [preId]="i" [rootForm]="lieuxBav.controls[i]" classeColLabel="col-8" 
                        classeColInput="col-2" classeSupplInput="text-right" label="aaLieuBavNbPermEtp" [max]="9999" [erreursCroisees]="['ctrlA65Bav']"
                        infoBulle="3 personnes présentes sur une demi-journée = 3 demi-journées travaillées">
                      </bis-integer-inline-input-keypad>
                      <bis-affiche-erreurs-croisees [rootForm]="lieuxBav.controls[i]" colorErreur="danger"
                        labelErreur="ctrlA65Bav">
                      </bis-affiche-erreurs-croisees>
                      <bis-affiche-alertes [labelAlerte]="'alertA43Bav_' + i"></bis-affiche-alertes>
                  </div>
              </div>
              <div class="form-row">
                  <div class="col-md-1"></div>
                  <div class="col-md-10">
                    <bis-integer-inline-input-keypad [preId]="i" [rootForm]="lieuxBav.controls[i]" classeColLabel="col-8" classeColInput="col-2" classeSupplInput="text-right" 
                        label="aaLieuBavNbVict" [max]="99999" infoBulle="(physiques et morales)">
                    </bis-integer-inline-input-keypad>
                  </div>
            </div>
          </mat-expansion-panel>
          </div>
          </mat-accordion>
          <div class="form-row">
              <div class="col-md-6">
                <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuBavNb" [max]="99" enLectureSeule="true"
                  classeColLabel="col-6" classeColInput="col-4"      
                  infoBulle="Cette zone est calculée automatiquement à partir du nombre de bav ajouté(s)">
                </bis-integer-inline-input>
            </div>
            <div class="col-md-6">
                <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuBavNbPermTot" [max]="9999" enLectureSeule="true"
                  classeColLabel="col-6" classeColInput="col-4">
                </bis-integer-inline-input>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-10">
                <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuBavNbPermEtpTot" [max]="99999" 
                  enLectureSeule="true" classeColLabel="col-6" classeColInput="col-4">
                </bis-integer-inline-input>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-10">
                <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuBavNbVictTot" [max]="999999" 
                    enLectureSeule="true" classeColLabel="col-6" classeColInput="col-4">
                </bis-integer-inline-input>
            </div>
          </div>  
        </div>
      </div>
  </div>
</div>  


<div *ngIf="rootForm && lieuxBav && (modeRenduService.enModeImpression$ | async)">
  <div class="form-row mx-2 pb-3" *ngIf="rootForm && lieuxBav">
    <div class="col" [formGroup]="rootForm">
      <div>
        <div *ngFor="let item of lieuxBav.controls; let i = index">
            <div class="form-row">
                <div class="col-md-8">
                  <bis-filtered-select-input-keypad [preId]="i" [rootForm]="lieuxBav.controls[i]" nbChoixVisiblePossible="10" label="aaLieuBavIelst" 
                      nomNomenclature="ielstBav" [montreCode]="false" [enLectureSeule]="true">
                  </bis-filtered-select-input-keypad>
                </div>
                <div class="col-md-4">
                  <bis-filtered-select-input-keypad [preId]="i" [rootForm]="lieuxBav.controls[i]" label="aaLieuBavQp" 
                      infoBulle="Préciser dans le menu déroulant si le lieu de permanence est en quartier prioritaire" nomNomenclature="ouiNonNsp">
                  </bis-filtered-select-input-keypad>
                </div>
            </div>
            <div class="form-row">
                <div class="col-md-1"></div>
                <div class="col-md-10">
                  <bis-integer-inline-input-keypad [preId]="i" [rootForm]="lieuxBav.controls[i]" classeColLabel="col-8" classeColInput="col-2" classeSupplInput="text-right" 
                      label="aaLieuBavNbPerm" [max]="999" infoBulle="1 demi-journée = 3h" [erreursCroisees]="['ctrlA64Bav']">
                  </bis-integer-inline-input-keypad>
                  <bis-affiche-erreurs-croisees [rootForm]="lieuxBav.controls[i]" colorErreur="danger"
                    labelErreur="ctrlA64Bav">
                  </bis-affiche-erreurs-croisees>
                </div>
            </div>
            <div class="form-row">
                <div class="col-md-1"></div>
                <div class="col-md-10">
                    <bis-integer-inline-input-keypad [preId]="i" [rootForm]="lieuxBav.controls[i]" classeColLabel="col-8" 
                      classeColInput="col-2" classeSupplInput="text-right" label="aaLieuBavNbPermEtp" [max]="9999" [erreursCroisees]="['ctrlA65Bav']"
                      infoBulle="3 personnes présentes sur une demi-journée = 3 demi-journées travaillées">
                    </bis-integer-inline-input-keypad>
                    <bis-affiche-erreurs-croisees [rootForm]="lieuxBav.controls[i]" colorErreur="danger"
                      labelErreur="ctrlA65Bav">
                    </bis-affiche-erreurs-croisees>
                    <bis-affiche-alertes [labelAlerte]="'alertA43Bav_' + i"></bis-affiche-alertes>
                </div>
            </div>
            <div class="form-row">
                <div class="col-md-1"></div>
                <div class="col-md-10">
                  <bis-integer-inline-input-keypad [preId]="i" [rootForm]="lieuxBav.controls[i]" classeColLabel="col-8" classeColInput="col-2" classeSupplInput="text-right" 
                      label="aaLieuBavNbVict" [max]="99999" infoBulle="(physiques et morales)">
                  </bis-integer-inline-input-keypad>
                </div>
          </div>
        </div>
        <div class="form-row mt-4">
            <div class="col-md-6">
              <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuBavNb" [max]="99" enLectureSeule="true"
                classeColLabel="col-6" classeColInput="col-4"      
                infoBulle="Cette zone est calculée automatiquement à partir du nombre de bav ajouté(s)">
              </bis-integer-inline-input>
          </div>
          <div class="col-md-6">
              <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuBavNbPermTot" [max]="9999" enLectureSeule="true"
                classeColLabel="col-6" classeColInput="col-4">
              </bis-integer-inline-input>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-10">
              <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuBavNbPermEtpTot" [max]="99999" 
                enLectureSeule="true" classeColLabel="col-6" classeColInput="col-4">
              </bis-integer-inline-input>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-10">
              <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuBavNbVictTot" [max]="999999" 
                  enLectureSeule="true" classeColLabel="col-6" classeColInput="col-4">
              </bis-integer-inline-input>
          </div>
        </div>  
      </div>
    </div>
  </div>
</div>
